import { __assign, __read } from "tslib";
import React, { useCallback, useMemo, useReducer } from 'react';
// Action types
export var HarmonyThemeDataActionType;
(function (HarmonyThemeDataActionType) {
    HarmonyThemeDataActionType["setHarmonyThemeData"] = "setHarmonyThemeData";
})(HarmonyThemeDataActionType || (HarmonyThemeDataActionType = {}));
// Reducer
export var HarmonyThemeDataReducer = function (state, action) {
    switch (action.type) {
        case HarmonyThemeDataActionType.setHarmonyThemeData:
            return __assign(__assign({}, state), action.harmonyThemeData);
        default:
            return state;
    }
};
export var HarmonyThemeDataStateContext = React.createContext(undefined);
export var HarmonyThemeDataActionContext = React.createContext({
    setHarmonyThemeData: function (_harmonyThemeData) {
        /* initial no-op */
    },
});
// Create a custom hook to expose the state and setState actions to the context provider
var useHarmonyStore = function () {
    var _a = __read(useReducer(HarmonyThemeDataReducer, undefined), 2), harmonyThemeData = _a[0], dispatch = _a[1];
    var setHarmonyThemeDataCallback = useCallback(function (harmonyThemeData) {
        dispatch({
            type: HarmonyThemeDataActionType.setHarmonyThemeData,
            harmonyThemeData: harmonyThemeData,
        });
    }, [dispatch]);
    var harmonyThemeDataActionCreators = useMemo(function () {
        return {
            setHarmonyThemeData: setHarmonyThemeDataCallback,
        };
    }, [setHarmonyThemeDataCallback]);
    return useMemo(function () {
        return {
            harmonyThemeData: harmonyThemeData,
            harmonyThemeDataActionCreators: harmonyThemeDataActionCreators,
        };
    }, [harmonyThemeData, harmonyThemeDataActionCreators]);
};
export var HarmonyThemeDataProvider = function (_a) {
    var children = _a.children;
    var _b = useHarmonyStore(), harmonyThemeData = _b.harmonyThemeData, harmonyThemeDataActionCreators = _b.harmonyThemeDataActionCreators;
    return (React.createElement(HarmonyThemeDataActionContext.Provider, { value: harmonyThemeDataActionCreators },
        React.createElement(HarmonyThemeDataStateContext.Provider, { value: harmonyThemeData }, children)));
};
//# sourceMappingURL=HarmonyThemeDataProvider.js.map